export enum PayloadType {
    INVITE_FRIEND = 'inviteFriend',
    CHALLENGE_FRIEND = 'challengeFriend',
    SEND_GIFT = 'sendGift',
    SHARE_BEAT_HIGHSCORE_LEVEL = 'shareBeatHighscoreLevel',
    SHARE_3_STAR_REWARD = 'share3StarReward',
    SHARE_POSTCARD = 'sharePostcard',
    SHARE_PRIZEWHEEL = 'sharePrizewheel',

    // String values correspond with legacy payloads (old bot messages will remain redeemable).
    SEND_LIFE = 'SetLive',
    REQUEST_LIFE = 'GetLive',
    GATE_UNLOCK_ADD_FRIEND_REQUEST = 'GetStar',
    GATE_UNLOCK_ADD_FRIEND_RESPONSE = 'SetStar',
    HELP_FRIEND = 'helpFriend',
}
